import { makeObservable, observable } from 'mobx';
import { RouterStore } from 'mobx-react-router';
import { setStoreToWindowObject } from '../utils/store';
import AppStore from './AppStore';
import ChatInputStore from './ChatInputStore';
import InquiryPageStore from './InquiryPageStore';
import InquiryStore from './InquiryStore';
import LayoutStore from './LayoutStore';
import LoginStore from './LoginStore';
import MessageStore from './MessageStore';
import PreviewModalStore from './PreviewModalStore';
import SearchStore from './SearchStore';
import ServiceStore from './ServiceStore';
import SocketStore from './SocketStore';
import UserStore from './UserStore';
import OmniLoginStore from './OmniLoginStore';
import FaqStore from './FaqStore';
import TravelStore from './partner/TravelStore';
import { IGetUserResponse } from '../interfaces/user.interface';

export default class RootStore {
  @observable routerStore: RouterStore;
  @observable appStore: AppStore;
  @observable chatInputStore: ChatInputStore;
  @observable inquiryPageStore: InquiryPageStore;
  @observable inquiryStore: InquiryStore;
  @observable layoutStore: LayoutStore;
  @observable loginStore: LoginStore;
  @observable messageStore: MessageStore;
  @observable previewModalStore: PreviewModalStore;
  @observable searchStore: SearchStore;
  @observable serviceStore: ServiceStore;
  @observable socketStore: SocketStore;
  @observable userStore: UserStore;
  @observable faqStore: FaqStore;
  @observable omniLoginStore: OmniLoginStore;
  @observable partnerStore: TravelStore | undefined;

  // intentional redundancy for multiple partners
  // this is initialized at AppStore
  initializePartnerState = (user: IGetUserResponse) => {
    // this.partnerStore = user.user.serviceId === 1003 && new TravelStore(this);
    this.partnerStore = new TravelStore(this);
  };

  constructor(routerStore: RouterStore) {
    setStoreToWindowObject('root', this);

    this.routerStore = routerStore;
    this.appStore = new AppStore(this);
    this.chatInputStore = new ChatInputStore(this);
    this.inquiryPageStore = new InquiryPageStore(this);
    this.inquiryStore = new InquiryStore(this);
    this.layoutStore = new LayoutStore(this);
    this.loginStore = new LoginStore(this);
    this.messageStore = new MessageStore(this);
    this.previewModalStore = new PreviewModalStore(this);
    this.searchStore = new SearchStore(this);
    this.serviceStore = new ServiceStore(this);
    this.socketStore = new SocketStore(this);
    this.userStore = new UserStore(this);
    this.omniLoginStore = new OmniLoginStore(this);
    this.faqStore = new FaqStore(this);
    makeObservable(this);
    this.appStore.initApp(
      this.routerStore.history.location.pathname,
      window.location.search,
    );
  }
}
